export function SystemHero() {
  return (
    <section
      id="home"
      className="introduction wrap"
      aria-labelledby="hero-heading"
    >
      <p className="micro introduction-topline">
        KEVIN HERNANDEZ-NINO / COMPUTER ENGINEER
      </p>
      <h1 id="hero-heading">
        Built with logic.
        <br />
        <span>Shaped around people.</span>
      </h1>
      <p className="introduction-description">
        I’m Kevin. I build native apps and work across software, hardware, and
        the systems that connect them.
      </p>
    </section>
  );
}
